module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Welcome to Ralph PR John Smith")]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4142adf5!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ArticleUsername.vue
// module id = 29
// module chunks = 1